import BlankEvent from '@components/blank/BlankEvent';
import Column from '@components/Column';
import InfinityScrollTrigger from '@components/InfinityScrollTrigger';
import Loading from '@components/Loading';

import EventItem from './EventItem';
import useEvents from './hooks/useEvents';
import styles from './styles.module.scss';

function EventList() {
  const {
    events, fetchNextPage, isLoading, isBlank,
  } = useEvents();
  return (
        <Column fullWidth as='main' spacing={18}
                align='center'
                className={styles.container}>
            {isBlank && (
                <BlankEvent/>
            )}
            {events.map((event) => (
                <EventItem key={event.id}
                           event={event} />
            ))}
            {isLoading && (
                <Loading size='small' />
            )}
            <InfinityScrollTrigger trigger={fetchNextPage} />
        </Column>
  );
}

export default EventList;
